// import main from "./_main.store";
// import config from "./_configuration.store";
// import entity from "./_entity.store";
// import user from "./_user.store";
import lang from "./_lang.store";
// import toast from "./_toast.store";

export default {
  state: {
    // ...main.state,
    // ...config.state,
    // ...entity.state,
    // ...user.state,
    ...lang.state,
    // ...toast.state
  },
  getters: {
    // ...main.getters,
    // ...config.getters,
    // ...entity.getters,
    // ...user.getters,
    ...lang.getters,
    // ...toast.getters
  },
  mutations: {
    // ...main.mutations,
    // ...config.mutations,
    // ...entity.mutations,
    // ...user.mutations,
    ...lang.mutations,
    // ...toast.mutations
  },
  actions: {
    // ...main.actions,
    // ...config.actions,
    // ...entity.actions,
    // ...user.actions,
    ...lang.actions,
    // ...toast.actions
  },
};
